<template>
  <div v-if="pack" class="p-16">
    <div class="max-w-3xl mx-auto space-y-8">
      <h3 class="uppercase text-center tracking-wider font-light">
        {{ pack.name }}
      </h3>

      <PackageCustomization :entity="pack" @create-order="createOrder" @changed="setPackageItems" />

      <div class="mt-16 flex items-baseline">
        <div class="bg-gray-100 p-3 ml-auto rounded">
          <div class="flex -mx-3 items-baseline">
            <div class="flex-1 px-3 border-r">
              <BaseButton success @click="createOrder"> Παραγγελία </BaseButton>
            </div>
            <div class="flex-1 px-8 py-2">Τελική Τιμή</div>
            <div class="w-24 px-4 font-medium text-right border-l">{{ totalPrice }} &euro;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import orderLinesMixin from '@/mixins/orderLinesMixin';
import PackageCustomization from '@/components/Account/PackageCustomization.vue';

export default {
  name: 'PackageIdView',
  mixins: [orderLinesMixin],
  components: {
    PackageCustomization,
  },
  props: {
    packageId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('ui/packages', ['pack']),
    totalPrice() {
      return this.orderLines.reduce((acc, cur) => acc + cur.price, 0);
    },
  },
  async created() {
    const { packageId } = this;

    await this.fetchPackage({ packageId });
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...mapActions('ui/packages', ['fetchPackage']),
    ...mapMutations('ui/packages', ['setCurrent']),
    setPackageItems(packageItems) {
      this.packageItems = [...packageItems];
      this.createOrderLineFromPackage(this.pack);
    },
    createOrder() {
      window.localStorage.setItem('orderLines', JSON.stringify(this.orderLines));
      this.$router.push({
        name: 'accounts.orders.create',
        params: { ...this.$route.params },
      });
    },
  },
};
</script>
